import { Lang } from '../../Lang';
import { FormGroup2, FormRow2, Input2, InputType2, LangTextV2, ModalDialog2, ModalDialogType2 } from 'bambooo';
export class OrganizationEditModal extends ModalDialog2 {
    /**
     * constructor
     */
    constructor() {
        super({ modalType: ModalDialogType2.large });
        /**
         * ID from organization
         * @protected
         */
        this._id = null;
        const bodyCard = jQuery('<div class="card-body"/>').appendTo(this.getBody());
        const groupName = new FormGroup2({ label: new LangTextV2({ text: 'Name' }) });
        groupName.appendTo(bodyCard);
        this._inputName = new Input2({});
        this._inputName.appendTo(groupName);
        const groupCountry = new FormGroup2({ label: new LangTextV2({ text: 'Country' }) });
        groupCountry.appendTo(bodyCard);
        this._inputCountry = new Input2({});
        this._inputCountry.appendTo(groupCountry);
        const groupLocation = new FormGroup2({ label: new LangTextV2({ text: 'Location' }) });
        groupLocation.appendTo(bodyCard);
        this._inputLocation = new Input2({});
        this._inputLocation.appendTo(groupLocation);
        const rowPosition = new FormRow2({});
        rowPosition.appendTo(bodyCard);
        const groupLon = new FormGroup2({ label: new LangTextV2({ text: 'Lon' }) });
        groupLon.appendTo(rowPosition.createCol(6));
        this._inputLon = new Input2({});
        this._inputLon.appendTo(groupLon);
        const groupLat = new FormGroup2({ label: new LangTextV2({ text: 'Lat' }) });
        groupLat.appendTo(rowPosition.createCol(6));
        this._inputLat = new Input2({});
        this._inputLat.appendTo(groupLat);
        // AROC office-report fields ---------------------------------------------------------------------------------
        jQuery('<hr/>').appendTo(bodyCard);
        jQuery('<h6 class="text-muted"></h6>').text('AROC').appendTo(bodyCard);
        const rowPlace = new FormRow2({});
        rowPlace.appendTo(bodyCard);
        const groupProvince = new FormGroup2({ label: new LangTextV2({ text: 'Province' }) });
        groupProvince.appendTo(rowPlace.createCol(4));
        this._inputProvince = new Input2({});
        this._inputProvince.appendTo(groupProvince);
        const groupIsland = new FormGroup2({ label: new LangTextV2({ text: 'Island' }) });
        groupIsland.appendTo(rowPlace.createCol(4));
        this._inputIsland = new Input2({});
        this._inputIsland.appendTo(groupIsland);
        const groupPort = new FormGroup2({ label: new LangTextV2({ text: 'Port' }) });
        groupPort.appendTo(rowPlace.createCol(4));
        this._inputPort = new Input2({});
        this._inputPort.appendTo(groupPort);
        const rowContact = new FormRow2({});
        rowContact.appendTo(bodyCard);
        const groupEmail = new FormGroup2({ label: new LangTextV2({ text: 'E-Mail' }) });
        groupEmail.appendTo(rowContact.createCol(6));
        this._inputEmail = new Input2({});
        this._inputEmail.appendTo(groupEmail);
        const groupWeb = new FormGroup2({ label: new LangTextV2({ text: 'Website' }) });
        groupWeb.appendTo(rowContact.createCol(6));
        this._inputWeb = new Input2({});
        this._inputWeb.appendTo(groupWeb);
        const rowAroc1 = new FormRow2({});
        rowAroc1.appendTo(bodyCard);
        const groupArocRegion = new FormGroup2({ label: new LangTextV2({ text: 'AROC region' }) });
        groupArocRegion.appendTo(rowAroc1.createCol(4));
        this._inputArocRegion = new Input2({});
        this._inputArocRegion.appendTo(groupArocRegion);
        const groupArocNumber = new FormGroup2({ label: new LangTextV2({ text: 'AROC number' }) });
        groupArocNumber.appendTo(rowAroc1.createCol(4));
        this._inputArocNumber = new Input2({});
        this._inputArocNumber.appendTo(groupArocNumber);
        const groupArocBoats = new FormGroup2({ label: new LangTextV2({ text: 'Authorized boats' }) });
        groupArocBoats.appendTo(rowAroc1.createCol(4));
        this._inputArocAuthorizedBoats = new Input2({ type: InputType2.number });
        this._inputArocAuthorizedBoats.appendTo(groupArocBoats);
        const groupArocReference = new FormGroup2({ label: new LangTextV2({ text: 'AROC reference' }) });
        groupArocReference.appendTo(bodyCard);
        this._inputArocReference = new Input2({});
        this._inputArocReference.appendTo(groupArocReference);
        // buttons -----------------------------------------------------------------------------------------------------
        this.addButtonClose(Lang.i().l('Close'));
        this.addButtonSave(Lang.i().l('Save changes'), true);
    }
    /**
     * Set id from organization
     * @param {number} id
     */
    setOrganizationId(id) {
        this._id = id;
    }
    /**
     * Return id from organization
     * @returns {number|null}
     */
    getOrganizationId() {
        return this._id;
    }
    /**
     * Set the organization name
     * @param {string} name
     */
    setName(name) {
        this._inputName.setValue(name);
    }
    /**
     * Return the organization name
     * @returns {string}
     */
    getName() {
        return this._inputName.getValue();
    }
    /**
     * Set the country for organization
     * @param {string} country
     */
    setCountry(country) {
        this._inputCountry.setValue(country);
    }
    /**
     * Return the country for organization
     * @returns {string}
     */
    getCountry() {
        return this._inputCountry.getValue();
    }
    /**
     * Set the location for organization
     * @param {string} location
     */
    setLocation(location) {
        this._inputLocation.setValue(location);
    }
    /**
     * Return the location from organization
     * @returns {string}
     */
    getLocation() {
        return this._inputLocation.getValue();
    }
    /**
     * Set the Lon for organization
     * @param {string} lon
     */
    setLon(lon) {
        this._inputLon.setValue(lon);
    }
    /**
     * Return the lon from organization
     */
    getLon() {
        return this._inputLon.getValue();
    }
    /**
     * Set the lat for organization
     * @param {string} lat
     */
    setLat(lat) {
        this._inputLat.setValue(lat);
    }
    /**
     * Return the lat from organization
     * @returns {string}
     */
    getLat() {
        return this._inputLat.getValue();
    }
    setProvince(v) {
        this._inputProvince.setValue(v);
    }
    getProvince() {
        return this._inputProvince.getValue();
    }
    setIsland(v) {
        this._inputIsland.setValue(v);
    }
    getIsland() {
        return this._inputIsland.getValue();
    }
    setPort(v) {
        this._inputPort.setValue(v);
    }
    getPort() {
        return this._inputPort.getValue();
    }
    setEmail(v) {
        this._inputEmail.setValue(v);
    }
    getEmail() {
        return this._inputEmail.getValue();
    }
    setWeb(v) {
        this._inputWeb.setValue(v);
    }
    getWeb() {
        return this._inputWeb.getValue();
    }
    setArocReference(v) {
        this._inputArocReference.setValue(v);
    }
    getArocReference() {
        return this._inputArocReference.getValue();
    }
    setArocRegion(v) {
        this._inputArocRegion.setValue(v);
    }
    getArocRegion() {
        return this._inputArocRegion.getValue();
    }
    setArocNumber(v) {
        this._inputArocNumber.setValue(v);
    }
    getArocNumber() {
        return this._inputArocNumber.getValue();
    }
    setArocAuthorizedBoats(v) {
        this._inputArocAuthorizedBoats.setValue(v > 0 ? `${v}` : '');
    }
    getArocAuthorizedBoats() {
        const raw = this._inputArocAuthorizedBoats.getValue().trim();
        if (raw === '') {
            return 0;
        }
        const n = parseInt(raw, 10);
        return Number.isFinite(n) && n > 0 ? n : 0;
    }
    /**
     * resetValues
     */
    resetValues() {
        this._id = null;
        this.setName('');
        this.setCountry('');
        this.setLocation('');
        this.setLon('');
        this.setLat('');
        this.setProvince('');
        this.setIsland('');
        this.setPort('');
        this.setEmail('');
        this.setWeb('');
        this.setArocReference('');
        this.setArocRegion('');
        this.setArocNumber('');
        this.setArocAuthorizedBoats(0);
    }
}
